<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape  shape-default bg-gradient-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-12">
                <h1 class="display-4  text-white">
                  Nós temos as melhores soluções tecnológicas para atender as
                  mais diversas demandas do seu condomínio.
                </h1>
                <p class="lead  text-white font-weight-bold">Vem adminsitrar com a gente!</p>
                <div class="d-lg-none d-md-block ml-lg-4 mt-5">
                  <a
                    href="#"
                    @click="validaLogin"
                    class="btn btn-neutral btn-icon"
                  >
                    <span class="btn-inner--icon">
                      <i class="ni ni-app mr-2"></i>
                    </span>
                    <span class="nav-link-inner--text"
                      >Área do Condômino</span
                    >
                  </a>
                  <modal
                    :show.sync="modals.modal3"
                    body-classes="p-0"
                    modal-classes="modal-dialog-centered modal-sm"
                  >
                    <card
                      type="secondary"
                      shadow
                      header-classes="bg-white pb-5"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0"
                    >
                      <template>
                        <div class="text-center text-muted mb-4">
                          <h5>Insira suas credenciais para logar</h5>
                        </div>

                        <form role="form">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <input
                                  ref="email"
                                  type="email"
                                  v-model="email"
                                  class="form-control"
                                  id="exampleFormControlInput1"
                                  placeholder="email"
                                />
                              </div>
                              <div class="form-group">
                                <input
                                  type="password"
                                  v-model="senha"
                                  class="form-control"
                                  id="exampleFormControlInput2"
                                  placeholder="senha"
                                />
                              </div>
                              <div class="text-center">
                                <base-button
                                  type="primary"
                                  class="my-4"
                                  @click="validaLogin()"
                                  >Logar</base-button
                                >
                              </div>
                              <div class="text-center">
                                <h7 class="text-warning" v-if="invalido"
                                  >Dados de Login Incorretos</h7
                                >
                              </div>
                            </div>
                          </div>
                        </form>
                      </template>
                    </card>
                  </modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-building"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">
                    Gestão Condominial
                  </h6>
                  <p class="description mt-3">
                    Nossa equipe especializada em gestão, trabalha em parceria
                    com o síndico para que seja possível garantir a melhoria
                    constante de procedimentos em geral, além de assessorar
                    síndicos iniciantes para que os mesmos possam exercer com
                    mais confiança suas funções.
                  </p>
                  <base-button
                    tag="a"
                    href="#"
                    @click="scrollToElement('admin', $event)"
                    type="primary"
                    class="mt-4"
                  >
                    Saiba mais
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="fa fa-line-chart"
                    type="success"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-success text-uppercase">
                    Otimização de Recursos
                  </h6>
                  <p class="description mt-3">
                    Auxiliamos o síndico na elaboração de projetos que
                    proporcionem economia de curto, médio e longo prazo para o
                    condomínio e também indicamos as melhores soluções para que
                    seja possível o aproveitamento máximo de todos os recursos
                    disponibilizados no condomínio.
                  </p>
                  <base-button
                    tag="a"
                    href="#"
                    @click="scrollToElement('recursos', $event)"
                    type="success"
                    class="mt-4"
                  >
                    Saiba mais
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-bulb-61"
                    type="warning"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-warning text-uppercase">
                    Soluções Inovadoras
                  </h6>
                  <p class="description mt-3">
                    Buscamos unir gestão e tecnologia para que assim, seja
                    possível atender as grandes demandas do cotidiano de maneira
                    precisa e com a máxima eficácia, contribuindo desta forma
                    para uma gestão assertiva e transparente, melhorando a vida
                    dos moradores.
                  </p>
                  <base-button
                    tag="a"
                    href="#"
                    @click="scrollToElement('icondev', $event)"
                    type="warning"
                    class="mt-4"
                  >
                    Saiba mais
                  </base-button>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section ref="admin" class="section bg-secondary">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <img
                v-lazy="'img/theme/img-1-1200x1000.jpg'"
                class="card-img-top"
              />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon
                    points="0,52 583,95 0,95"
                    class="fill-default"
                  ></polygon>
                  <polygon
                    points="0,42 583,95 683,0 0,95"
                    opacity=".2"
                    class="fill-default"
                  ></polygon>
                </svg>
                <h4 class="display-3 font-weight-bold text-white">
                  Gestão Condominial
                </h4>
                <p class="lead text-italic text-white">
                  Cuidamos dos aspectos administrativos, com experiência e
                  respeito a convenção, regulamento interno e a legislação em
                  vigor.
                </p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <icon
                name="ni ni-building"
                class="mb-5"
                size="lg"
                type="primary"
                shadow
                rounded
              ></icon>

              <h3>Conhecemos de condomínios</h3>
              <p class="lead">
                Já imaginou conseguir ajuda especializada de forma rápida e
                objetiva?
              </p>
              <p>
                Para que o dia a dia do seu condomínio seja tranquilo é
                imprescindível que a administração do mesmo seja feita de
                maneira eficiente e que esteja apta a resolver de maneira célere
                os mais diversos problemas que surgem, e é utilizando da
                expertise que temos na atuação de nossos colaboradores como
                síndicos que podemos oferecer uma resposta rápida as mais
                diversas solicitações.
              </p>
              <p>
                Precisa de ajuda para lidar com a Gestão Financeira, Gestão de
                Pessoal, Gestão de Compras, Gestão de Contratos, Gestão de
                manutenção e Assembleias Gerais?
              </p>
              <!--<a href="#" @click="scrollToElement('proposta', $event)" class="font-weight-bold text-primary mt-5">Deixe a gente administrar com você. Clique aqui
                                e solicite uma proposta.
                            </a>-->
            </div>
          </div>
        </div>
      </div>
    </section>
    <section ref="recursos" class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-gradient-success shape-skew">
        <span></span>
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-lg-2 ml-lg-auto">
            <div class="position-relative pl-md-2">
              <img src="img/ill/ill-2.svg" class="img-center img-fluid" />
            </div>
          </div>
          <div class="col-lg-6 order-lg-1">
            <div class="d-flex px-2">
              <div>
                <icon
                  name="fa fa-line-chart"
                  size="lg"
                  class="bg-gradient-white"
                  color="success"
                  shadow
                  rounded
                ></icon>
              </div>
              <div class="pl-4">
                <h4 class="display-3 text-white">Otimização de Recursos</h4>
                <p class="text-white">
                  Nossos relatórios trarão informações precisas para melhoria
                  continua do seu condomínio.
                </p>
              </div>
            </div>
            <card shadow class="shadow-lg--hover mt-3">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-tv-2"
                    gradient="success"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-success">
                    Relatórios gerados com uso do Power BI
                  </h5>
                  <p>
                    Nossos dashboards poderosos trarão uma nova visão do seu
                    condomínio.
                  </p>
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-3">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-chart-pie-35"
                    gradient="success"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-success">Informação é Poder</h5>
                  <p>
                    Se você já está cansado de ter que extrair informações dos
                    balancetes gigantes, vem experimentar o modo Recife de gerar
                    informação.
                  </p>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>
    <section ref="icondev" class="section section-lg">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img src="img/theme/promo-1.png" class="img-fluid floating" />
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <icon
                name="ni ni-settings-gear-65"
                class="mb-5"
                size="lg"
                type="warning"
                shadow
                rounded
              ></icon>
              <h3>Tudo na palma da sua mão</h3>
              <p>
                Já pensou em saber a inadimplência atual do seu condomínio por
                meio de um aplicativo? E acompanhar a vida financeira do seu
                condomínio com apenas alguns cliques?
              </p>
              <p>
                Então você está no lugar certo, através do nosso portal e
                aplicativo, você terá acesso a diversas funcionalidades:
              </p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="warning"
                      circle
                      class="mr-3"
                      icon="fa fa-barcode"
                    ></badge>
                    <h6 class="mb-0">Impressão de boletos</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="warning"
                      circle
                      class="mr-3"
                      icon="ni ni-calendar-grid-58"
                    ></badge>
                    <h6 class="mb-0">Reserva de área comum</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="warning"
                      circle
                      class="mr-3"
                      icon="ni ni-collection"
                    ></badge>
                    <h6 class="mb-0">Prestação de contas</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="warning"
                      circle
                      class="mr-3"
                      icon="ni ni-single-copy-04"
                    ></badge>
                    <h6 class="mb-0">Acesso a documentos</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--<section ref="proposta"  class="section section-shaped my-0 overflow-hidden">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">Quer uma proposta?</h4>
                            <p class="mt-0">É só nos informar os dados abaixo que faremos uma proposta especial para você.</p>
                            <base-input class="mt-2"
                                        alternative
                                        placeholder="Nome"
                                        addon-left-icon="ni ni-user-run">
                            </base-input>
                            <base-input class="mt-2"
                                        alternative
                                        placeholder="Condomínio"
                                        addon-left-icon="ni ni-user-run">
                            </base-input>
                            <base-input alternative
                                        placeholder="Email address"
                                        addon-left-icon="ni ni-email-83">
                            </base-input>
                            <base-input class="mb-4">
                                    <textarea class="form-control form-control-alternative" name="name" rows="4"
                                              cols="80" placeholder="Infome o endereço, CNPJ, quantidade de unidades, funcionários, valor da taxa condominial, etc..."></textarea>
                            </base-input>
                            <base-button type="default" round block size="lg">
                                Enviar Proposta
                            </base-button>
                        </card>
                    </div>
            </div>
            </div>
        </section> -->
  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";
import axios from "axios";
export default {
  name: "home",
  components: {
    Modal,
  },
  data() {
    return {
      modals: {
        modal3: false,
      },
      invalido: false,
      email: "",
      senha: "",
    };
  },
  methods: {
    scrollToElement(elementRef, event) {
      if (event) {
        event.preventDefault();
      }

      const el = this.$refs[elementRef];

      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
  validaLogin() {
      this.invalido = false;
       window.open(
            'https://recifeadministr.superlogica.net/clients/areadocondomino',
            '_self'
          )
    },
  },
};
</script>
